<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M13.6404 10.9998L3.00203 10.9998L3.00203 8.99978L13.636 8.99978L12.2726 7.63698L13.4544 6.45418L16.9998 10.0006L15.2282 11.774L13.4544 13.5459L12.2728 12.3642L13.6404 10.9998Z"
    fill="currentColor"
  />
</svg>
